import { render, staticRenderFns } from "./about-dialog.vue?vue&type=template&id=b55dbc00&"
import script from "./about-dialog.vue?vue&type=script&lang=js&"
export * from "./about-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports